import axios from "axios";
import getApiUrl from "../../helpers/api-urls";
import * as types from "../../action-type";
import * as commonActions from "../../common.actions";
import { cacheManager, getApiUniqueRequestId } from "../../helpers/util-common";

export const getUploadTokenAction = (postData: any, dispatch: any, callback: (response: string, dispatch?: any) => void) => {
  /**** One drive upload code start */
  dispatch(commonActions.setLoader(true));
  let upload_url = getApiUrl("documents", "getUploadToken");
  const uploadData = {
    Committee: postData.Committee,
    FileName: postData.FileName,
    DocumentCategory: "Ballot",//getDocumentCategoryInfo(postData.DocumentCategoryId)?.name,
    BallotFolder: postData.BallotFolder,
  };
  // not required to send data
  axios
    .post(upload_url, uploadData)
    .then((response: any) => {
      if (response.data.status) {
        callback(response, dispatch);
      }
    })
    .catch((err) => {
      const uniqueRequestId = getApiUniqueRequestId(upload_url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const postCheckDocumentAction = (postData: any, dispatch: any, callback: (response: any) => void) => {
  let url = getApiUrl("documents", "postCheckDocument");
  axios
    .post(url, postData)
    .then((response) => {
      if (response.data.status) {
        callback(response.data.content);
      }
    })
    .catch((err) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const replaceDocumentAction = (postData: any, dispatch: any, callback: (response: any, dispatch?: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "replaceDocument");
  axios
    .put(url, postData)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data.content, dispatch);
      } else {
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
};

export const checkMimeTypeAction = (postData: object, dispatch: any, callback: Function) => {
  
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "checkMimeType");

  axios.post(url, postData)
    .then((response) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.status) {
        callback(response.data);
      } else {
        callback(false);
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
      callback(false);
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1315", uniqueRequestId));
    });
}

export const getUplaodTokenAction: any = (dispatch: any, callback: (response: any) => void) => {
   commonActions.ValidateOktaToken((oktaResponse: any) => {
     let oktaToken = oktaResponse;
      dispatch(commonActions.setLoader(true));
  let url = getApiUrl("openAPI", "getUplaodToken", true);
  axios
    .get(url,{
      headers: oktaToken,
    })
    .then((response: any) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.Status) {
        callback(response.data.Result);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
   })
 
}

export const getUploadSessionUrlAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    dispatch(commonActions.setLoader(true));
    let url = getApiUrl("openAPI", "getUploadSessionUrl", true);
    oktaToken["keep-body-params"] = "false";
    axios.post(url, data, {
      headers: { ...oktaToken },
    })
      .then((response: any) => {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.Status) {
          callback(response.data.Result);
        } else {
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
      });
  })  
}

export const saveMetaDataAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    dispatch(commonActions.setLoader(true));
    let url = getApiUrl("openAPI", "saveMetaData", true);
    oktaToken["keep-body-params"] = "true";
    axios.post(url, data, {
      headers: { ...oktaToken },
    })
      .then((response: any) => {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.Status) {
          callback(response.data.Result);
        } else {
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
      });
  })
}

export const captureBallotAuditLogAction: any = (data: any, dispatch: any)=>{
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "captureBallotAuditLog");
  axios
    .post(url, data)
    .then((response: any) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (!response.data.status) {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      } 
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
};

export const uploadBallotDocumentAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("documents", "uploadBallotDocument");
  axios
    .post(url, data)
    .then((response: any) => {
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        callback(response.data);
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setLoader(false));
    });
};

export const ConvertFileAction: any = (data: any, dispatch: any) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    dispatch(commonActions.setLoader(true));
    let url = getApiUrl("openAPI", "convertFile", true);
    oktaToken["keep-body-params"] = "false";
    axios
      .post(url, data, {
        headers: { ...oktaToken },
      })
      .then((response: any) => {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.ResponseStatus) {
          // Do Nothing
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
      });
  })
}
export const getBallotFolderDetailAction: any = (ballotfolder: string, dispatch, callback: (response: any) => void) => {
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    dispatch(commonActions.setLoader(true));
    let url = `${getApiUrl("openAPI", "getBallotFolderDetail", true)}/${ballotfolder}`;
    oktaToken["keep-body-params"] = "false";
    axios
      .get(url, {
        headers: { ...oktaToken },
      })
      .then((response: any) => {
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.Status) {
          callback(response.data.Result);
        }else{
          callback(response.data.Status);
          dispatch(commonActions.setMessage(true, response.data.message),uniqueRequestId);
        }
      })
      .catch((err) => {
        dispatch(commonActions.setLoader(false));
      });
  })
}

export const DeleteDocumentAction: any=(ondriveFileId: string, log: string, dispatch, callback:(response: any)=> void, 
allFormats: boolean = true)=>{
   commonActions.ValidateOktaToken((oktaResponse: any) => {
     let oktaToken = oktaResponse;
     dispatch(commonActions.setLoader(true));
  const queryString = `?allFormats=${allFormats}`
  let url = `${getApiUrl("openAPI", "deleteBallotDocument", true)}/${ondriveFileId}${queryString}`;
     if (log) {
       url += "&log=replace"
     }
  oktaToken["keep-body-params"]="false";
  axios
  .delete(url,{
    headers: {...oktaToken},
  })
  .then((response: any) => {
    const uniqueRequestId = getApiUniqueRequestId(url);
    dispatch(commonActions.setLoader(false));
    if (response.data.Status) {
      callback(response.data.Status);
    } 
  })
  .catch((err) => {
    dispatch(commonActions.setLoader(false));
  });
   })
  
}